module.exports = __webpack_public_path__ + "assets/faa350285e07c8de79be8afb0f591526.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_10.mp3
 ** module id = 36
 ** module chunks = 0
 **/